import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { CustomSelect } from 'src/app/models/customSelect';

@Injectable({
  providedIn: 'root',
})
export class CustomSelectService {
  private language = new BehaviorSubject('');
  currentLanguage = this.language.asObservable();
  public currentCurstomSelectSubject: BehaviorSubject<CustomSelect>;
  public currentCurstomSelect: Observable<CustomSelect>;

  constructor(
    // private httpClient: HttpClient
  ) {
    this.currentCurstomSelectSubject = new BehaviorSubject<CustomSelect>(new CustomSelect());
    this.currentCurstomSelect = this.currentCurstomSelectSubject.asObservable();
  }

  public get currentCurstomSelectValue(): CustomSelect {
    return this.currentCurstomSelectSubject.value;
  }

  public toogleLanguageSelect(action: string) {
    switch (action) {
      case 'toogle':
        this.currentCurstomSelectValue.showLanguage = !this.currentCurstomSelectValue.showLanguage;
        break;
      case 'false':
        this.currentCurstomSelectValue.showLanguage = false;
        break;
      default:
        this.currentCurstomSelectValue.showLanguage = !this.currentCurstomSelectValue.showLanguage;
        break;
    }
    this.currentCurstomSelectSubject.next(this.currentCurstomSelectValue);
  }

  // public toogleUserSelect(action: string) {
  //   switch (action) {
  //     case 'toogle':
  //       this.currentCurstomSelectValue.showUser = !this.currentCurstomSelectValue.showUser;
  //       break;
  //     case 'false':
  //       this.currentCurstomSelectValue.showUser = false
  //       break;
  //     default:
  //       this.currentCurstomSelectValue.showUser = !this.currentCurstomSelectValue.showUser;
  //       break;
  //   }
  //   this.currentCurstomSelectSubject.next(this.currentCurstomSelectValue);
  // }

}
